<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchTitle"></breadcrumb-search>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div>
            <img style="width: 56px; height: 56px" :src="item.img" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>月度统计</h3>
        <div>
          <el-button type="primary" @click="todetail">佣金明细</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="recordList" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '佣金记录表', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_daijiesuan.png'),
          title: '佣金总数',
          price: '0'
        },
        {
          img: require('../../../assets/icon_shangpin.png'),
          title: '冻结中',
          price: '0'
        },
        {
          img: require('../../../assets/icon_daijiesuan.png'),
          title: '分享身份佣金总数',
          price: '0'
        },
        {
          img: require('../../../assets/icon_shangpin.png'),
          title: '分享礼包佣金总数',
          price: '0'
        },
        {
          img: require('../../../assets/icon_daijiesuan.png'),
          title: '分享商品佣金总数',
          price: '0'
        }
      ],
      searchTitle: {
        list: [
          { title: '佣金记录', path: '', type: '0' }
        ]
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10
      },
      orderTime: [],//订单时间
      settleTime: [],//到账时间
      value1: [],
      brandList: [],
      columns: [
        // { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '佣金月份', prop: 'monthDate'
        },
        { label: '佣金总数', prop: 'totalAmount' },
        {
          label: '冻结中', prop: 'awaitAmount'
        },
        { label: '分享身份佣金总数', prop: 'vipAmount' },
        { label: '分享礼包佣金总数', prop: 'giftPackageAmount' },
        { label: '分享商品佣金总数', prop: 'goodsAmount' },
        {
          label: '操作', prop: 'settleStatusLabel', width: '100',
          render: (h, scope) => {
            return(
              <div>
                <el-button type="text" onClick={()=>this.todetail(scope.row)}>查看详情</el-button>
              </div>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      recordList: [],
      statistics: {},
      exporting: false
    }
  },
  created() {
    this.getCommissionRecordPageList()
    this.getCommissionStatistics()
  },
  methods: {
    todetail(row){
      this.$router.push({
        name: 'commissionDetail',
        query:{
          monthDate: row ? row.monthDate : ''
        }
      })
    },
    exportFn() {
      this.exporting = true;
      if (this.orderTime) {
        this.searchForm.orderTimeStart = this.orderTime[0];
        this.searchForm.orderTimeEnd = this.orderTime[1];
      } else {
        this.searchForm.orderTimeStart = '';
        this.searchForm.orderTimeEnd = '';
      }
      if (this.settleTime) {
        this.searchForm.settleTimeStart = this.settleTime[0];
        this.searchForm.settleTimeEnd = this.settleTime[1];
      } else {
        this.searchForm.settleTimeStart = '';
        this.searchForm.settleTimeEnd = '';
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/users/getCommissionRecordExport', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    getCommissionStatistics() {
      this.axios.get('/neworder/commission/statitics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.totalAmount;
            this.records[1].price = res.data.awaitAmount
            this.records[2].price = res.data.vipAmount;
            this.records[3].price = res.data.giftPackageAmount
            this.records[4].price = res.data.goodsAmount;
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'search') {

      } else {
        this.settleTime = []
        this.orderTime = []
        this.$refs['search'].resetFields()
      }
      this.getCommissionRecordPageList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getCommissionRecordPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getCommissionRecordPageList()
    },
    getCommissionRecordPageList() {
      
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/neworder/commission/getMonthPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.page.totalNum = res.data.totalNum;
            this.recordList = res.data.list;
          }
        })
    },
    // todetail() {
    //   this.$router.push({
    //     name: 'userDetail',
    //     query: {}
    //   })
    // }
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;

  img {
    padding: 16px 14px;
  }

  .right {
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }

    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/ .el-table {
  color: #303033
}
</style>

